<template>
  <el-dialog
    title=""
    customClass="refundDialog"
    :visible.sync="refundDialogVisible"
    :append-to-body="true"
    :modal-append-to-body="true"
  >
    <div class="title">订单退款</div>
    <div class="order-info">
      <div>
        <span class="key">订单编号</span>
        <span class="val">{{orderInfo.orderNo}}</span>
      </div>
      <template v-if="orderInfo.orderCat === 'FOOD'">
        <div>
          <span class="key">餐厅名称</span>
          <span class="val">{{orderInfo.merchIndustryName}}</span>
        </div>
        <div>
          <span class="key">产品名称</span>
          <span class="val">{{orderInfo.goodsName}}</span>
        </div>
        <div>
          <span class="key">联系方式</span>
          <span class="val">{{orderInfo.contactMobile}}</span>
        </div>
        <div>
          <span class="key">有效期至</span>
          <span class="val">{{orderInfo.foodCouponList[0].validStartDate && orderInfo.foodCouponList[0].validEndDate ? orderInfo.foodCouponList[0].validStartDate + '~' + orderInfo.foodCouponList[0].validEndDate : '永久有效' }}</span>
        </div>
        <div>
          <span class="key">数量</span>
          <span class="val">{{orderInfo.quantity}}</span>
        </div>
      </template>
      <template v-else-if="orderInfo.orderCat === 'HOTEL'">
        <div>
          <span class="key">酒店名称</span>
          <span class="val">{{orderInfo.merchIndustryName}}</span>
        </div>
        <div>
          <span class="key">房型名称</span>
          <span class="val">{{orderInfo.hotelRoomGoods.name}}</span>
        </div>
        <div>
          <span class="key">入住人</span>
          <span class="val">{{orderInfo.occupants}}</span>
        </div>
        <div>
          <span class="key">联系方式</span>
          <span class="val">{{orderInfo.contactMobile}}</span>
        </div>
        <div>
          <span class="key">入离时间</span>
          <span class="val">{{ orderInfo.useStartDate }}({{ orderInfo.startWeek }}) ~ {{ orderInfo.useEndDate }}({{ orderInfo.endWeek }})</span>
          <span class="val">共{{ orderInfo.quantity }}间{{ orderInfo.stayDays }}晚</span>
        </div>
      </template>
      <div>
        <span class="key">订单金额</span>
        <span class="val">¥{{orderInfo.itemTotal}}</span>
      </div>
      <div>
        <span class="key">退款金额</span>
        <span class="val">¥{{orderInfo.realMoneyOfRefund || 0}}</span>
        <!-- <span class="tip">* 如选择退款将收取5%的退款手续费</span> -->
      </div>
      <div v-if="orderInfo.feeOfRefund > 0">
        <span class="key">手续费</span>
        <span class="val">¥{{orderInfo.feeOfRefund || 0}}</span>
        <!-- <span class="tip">* 如选择退款将收取5%的退款手续费</span> -->
      </div>
    </div>
    <div class="footer-btn pointer">
      <div @click="handleRefund">确认退款</div>
    </div>
  </el-dialog>
</template>

<script>
import { loadRefundData, refund } from '@/api/myOrder'
import { config } from '@/constant/config'
export default {
  name: 'RefundDialog',
  data () {
    return {
      orderInfo: {},
      refundDialogVisible: false
    }
  },
  methods: {
    handleRefund () {
      const loading = this.$loading({
        lock: true,
        text: '请稍等',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        isNeedPoundage: 'T',
        isSpecialReturn: 'F',
        originalOrderNo: this.orderInfo.orderNo,
        refundReason: '官网退款',
        tenantId: config.TENANTID,
        merchId: config.MERCHID
      }
      if (this.orderInfo.orderCat === 'FOOD') {
        const refundDetails = []
        this.orderInfo.foodCouponList.forEach(val => {
          refundDetails.push({ couponNo: val.couponNo })
        })
        data.refundDetails = refundDetails
      } else if (this.orderInfo.orderCat === 'PACKAGES') {
        data.outRefundOrderNo = this.orderInfo.outOrderNo
        const refundTicketDetails = []
        this.orderInfo.packagesTicketList.forEach(item => {
          if (item.refundable) {
            refundTicketDetails.push({
              packagesTicketNo: item.packagesTicketNo
            })
          }
        })
        data.refundTicketDetails = refundTicketDetails
        data.refundQuantity = refundTicketDetails.length
      }
      refund(data, this.orderInfo.orderCat).then(res => {
        loading.close()
        if (res.code === 0) {
          this.refundDialogVisible = false
          this.$emit('loadDetail')
          this.$message.success('已发起退款')
        } else {
          this.$message.error(res.error)
        }
      }).catch(() => {
        loading.close()
      })
    },
    handleShowDialog (orderInfo) {
      this.orderInfo = orderInfo
      this.orderInfo.startWeek = this.getWeekday(new Date(this.orderInfo.useStartDate).getDay())
      this.orderInfo.endWeek = this.getWeekday(new Date(this.orderInfo.useEndDate).getDay())
      console.log(orderInfo)
      this.refundDialogVisible = true
    },
    loadPackagesRefundData (item) {
      const loading = this.$loading({
        lock: true,
        text: '请稍等',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        isNeedPoundage: 'T',
        isSpecialReturn: 'F',
        orderNo: item.orderNo,
        tenantId: config.TENANTID,
        merchId: config.MERCHID
      }
      loadRefundData(data).then(res => {
        loading.close()
        if (res.code === 0) {
          if (res.data) {
            this.orderInfo = {
              ...res.data,
              itemTotal: 0,
              realMoneyOfRefund: 0,
              feeOfRefund: 0,
              orderCat: 'PACKAGES'
            }
            const data = this.orderInfo.packagesTicketList.filter(item => item.refundable)
            if (data.length === 0) {
              this.$message.info('暂无可退款的票')
              return
            }
            data.forEach(item => {
              this.orderInfo.itemTotal += item.unitPrice
              this.orderInfo.realMoneyOfRefund += item.realRefundAmount
              this.orderInfo.feeOfRefund += item.refundPoundage
            })
            this.orderInfo.itemTotal = this.orderInfo.itemTotal.toFixed(2)
            this.orderInfo.realMoneyOfRefund = this.orderInfo.realMoneyOfRefund.toFixed(2)
            this.orderInfo.feeOfRefund = this.orderInfo.feeOfRefund.toFixed(2)
            this.refundDialogVisible = true
          } else {
            this.$message.info('暂无可退款的票')
          }
        } else {
          this.$message.error(res.error)
        }
      }).catch(() => {
        loading.close()
      })
    },
    getWeekday (day) {
      return ['周日', '周一', '周二', '周三', '周四', '周五', '周六'][day]
    }
  }
}
</script>
<style lang="scss">
.refundDialog{
  width: 660px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px rgba(14, 78, 114, 0.08);
  opacity: 1;
  border-radius: 16px;
  .title{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 21px;
    color: #A0393E;
    text-align: center;
    margin-bottom: 48px;
  }
  .order-info{
    padding: 0 40px;
    div{
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      color: #9FA1B0;
      margin-bottom: 12px;
      .key {
        width: 64px;
        text-align: right;
        display: inline-block;
      }
      .val {
        color: #44516F;
        margin-left: 30px;
      }
      .tip{
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        color: #FF0000;
        margin-left: 12px;
      }
    }
  }
  .footer-btn{
    width: 340px;
    height: 44px;
    background: #A0393E;
    opacity: 1;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
    line-height: 44px;
    color: #FFFFFF;
    text-align: center;
    margin: 68px auto 10px auto;
  }
}
</style>
